import CreditEvaluationsService from '@/service/creditEvaluations/CreditEvaluationsService'

async function checkCreditEvaluated(next) {
  // 신용 인증 이미 성공한 상태면 못들어가게 함
  try {
    if (await CreditEvaluationsService.getIsCreditEvaluated() === true) {
      alert('이미 등록된 상태입니다.')
      next({ name: 'dashboard' })
    } else {
      next()
    }
  } catch (e) {
    console.error(e)
    next({ name: 'dashboard' })
  }
}

export default [{
  name: 'factoring/form',
  path: '/factoring/form',
  beforeEnter(to, from, next) {
    if (window.DEBUG) {
      next()
      return
    }
    checkCreditEvaluated(next)
  },
  component: require('@/views/factoring/Form.vue').default
},
{
  name: 'factoring/confirm',
  path: '/factoring/confirm',
  beforeEnter(to, from, next) {
    if (window.DEBUG) {
      next()
      return
    }
    checkCreditEvaluated(next)
  },
  component: require('@/views/factoring/Confirm.vue').default
},
{
  name: 'factoring/success',
  path: '/factoring/success',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/factoring/Success.vue').default
},
{
  name: 'factoring/failure',
  path: '/factoring/failure',
  component: require('@/views/factoring/Failure.vue').default,
  props: true
},
{
  name: 'factoring/evaluation',
  path: '/factoring/evaluation',
  beforeEnter(to, from, next) {
    if (window.DEBUG) {
      next()
      return
    }
    checkCreditEvaluated(next)
  },
  component: require('@/views/factoring/Evaluation.vue').default
}]
